module.exports = __webpack_public_path__ + "img/reset_light_step_3.e88c863c.gif";